import { render } from "./App.vue?vue&type=template&id=4e67698e"
import script from "./App.vue?vue&type=script&lang=js"
export * from "./App.vue?vue&type=script&lang=js"

import "./App.vue?vue&type=style&index=0&id=4e67698e&lang=scss"

import exportComponent from "/home/schiavon/Documentos/Projects/RESTRICTED_WP/frontend_administrativo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__